import API from "./api";

const getToken = () => localStorage.getItem("token");

const authHeader = () => ({
  Authorization: `Bearer ${getToken()}`
});

// =====================
// SUMMARY
// =====================
export const getDashboardSummary = async () => {
  const res = await API.get("/dashboard/summary", {
    headers: authHeader()
  });
  return res.data;
};

// =====================
// SALES (WITH FILTER SUPPORT)
// =====================
export const getDailySales = async (params = {}) => {
  const res = await API.get("/dashboard/daily-sales", {
    params,
    headers: authHeader()
  });
  return res.data;
};

export const getMonthlySales = async (params = {}) => {
  const res = await API.get("/dashboard/monthly-sales", {
    params,
    headers: authHeader()
  });
  return res.data;
};

export const getYearlySales = async (params = {}) => {
  const res = await API.get("/dashboard/yearly-sales", {
    params,
    headers: authHeader()
  });
  return res.data;
};

export const getQuarterlySales = async (params = {}) => {
  const res = await API.get("/dashboard/quarterly-sales", {
    params,
    headers: authHeader()
  });
  return res.data;
};

// =====================
// ANALYTICS
// =====================
export const getTopProducts = async () => {
  const res = await API.get("/dashboard/top-products", {
    headers: authHeader()
  });
  return res.data;
};

export const getOrderStatus = async () => {
  const res = await API.get("/dashboard/order-status", {
    headers: authHeader()
  });
  return res.data;
};

// =====================
// PROFIT
// =====================
export const getProfit = async (params = {}) => {
  const res = await API.get("/dashboard/profit", {
    params,
    headers: authHeader()
  });
  return res.data;
};

export const getTotalProfit = async (params = {}) => {
  const res = await API.get("/dashboard/profit/total", {
    params,
    headers: authHeader()
  });
  return res.data;
};